import React from 'react'
import './components.css'
import { Link } from 'react-router-dom'

const Footer = () => {
    return (
        <div className='footer'>
            <div className='container-lg text-center text-lg-start'>
                <div className='d-lg-flex justify-content-between'>
                    <div className='footer__logo'>
                        {/* HY교육 */}
                        {/* Logo */}
                        <Link to={'/'} className='navbar-brand fw-bold'>
                            <img src='https://contents.sixshop.com/uploadedFiles/151941/default/image_1717761076642.png' alt='HY교육 로고' width={150} />
                        </Link>
                    </div>
                    <div className='d-flex justify-content-center justify-content-lg-start align-items-center gap-3 mt-4 mt-lg-0'>
                        <a href='/terms-of-service'>이용약관</a>
                        <span className='divider' />
                        <a href='/policy'>개인정보처리방침</a>
                    </div>
                </div>

                <div className='footer__address mt-4'>
                    <div>상호: 주식회사 HY교육 | 대표자 : 전대근 | 사업자등록번호 : 193-81-01917 | 학원등록번호 : 제12398호</div>
                    <address>주소 : 서울 구로구 디지털로34길 55 코오롱싸이언스밸리 2차 1층, 지하 1,2층</address>
                    <div>© 2024 by Corp HY Education  All rights reserved.</div>
                </div>
            </div>
        </div>
    )
}

export default Footer